var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.$style.root]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$trlMessage('tariffs.badge-label', _vm.tariffGroup)))]},{"tariffGroup":_vm.tariffGroup})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }